"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Index = void 0;
const _1 = require(".");
class Index {
    type = _1.HashTypes.standard;
    make;
}
exports.Index = Index;
//# sourceMappingURL=standard.js.map